import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, PropType, RenderFunction } from "vue";
import * as outlineIcons from "@heroicons/vue/outline";
import * as solidIcons from "@heroicons/vue/solid";
import { HeroIcons } from "./types";

type TMode = "outline" | "solid";


export default /*#__PURE__*/_defineComponent({
  __name: 'UiIcon',
  props: {
  icon: { type: String as PropType<HeroIcons>, required: true },
  type: { type: String as PropType<TMode>, default: "outline" },
  solid: { type: Boolean, default: false },
  size: { type: Number, default: 24 },
  color: { type: String, default: "currentColor" },
},
  setup(__props) {

const props = __props

_useCssVars(_ctx => ({
  "55eaaff0": (_unref(size))
}))



const icons: Record<string, Record<string, RenderFunction>> = {
  outline: outlineIcons,
  solid: solidIcons,
};

const renderFunction = computed(() => {
  const iconSet = props.solid ? icons.solid : icons.outline;
  return iconSet[props.icon + "Icon"];
});

const size = computed(() => `${props.size}px`);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(renderFunction)), {
    style: _normalizeStyle({ width: _unref(size), height: _unref(size), color: props.color })
  }, null, 8, ["style"]))
}
}

})